import { useEffect, useState } from "react";
import { ASSETS } from "../lib/assets";
import { Menu, X } from "lucide-react";

const NAV_ITEMS = [
    ["why", "Waarom"],
    ["examples", "Het verschil"],
    ["services", "Diensten"],
    ["process", "Proces"],
    ["faq", "FAQ"],
    ["contact", "Contact"],
];

export const Nav = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    const scrollTo = (id) => {
        setOpen(false);
        requestAnimationFrame(() => {
            document
                .getElementById(id)
                ?.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    };

    return (
        <>
            <nav
                data-testid="main-nav"
                className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                    scrolled || open
                        ? "bg-white/80 backdrop-blur-xl border-b border-black/5"
                        : "bg-transparent"
                }`}
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
                    <button
                        data-testid="nav-logo"
                        onClick={() =>
                            window.scrollTo({ top: 0, behavior: "smooth" })
                        }
                        className="flex items-center gap-2 group"
                    >
                        <img
                            src={ASSETS.marleaLogo}
                            alt="Marlea"
                            className="h-16 md:h-20 w-auto transition-transform duration-500 group-hover:scale-105 invert"
                        />
                    </button>
                    <div className="hidden md:flex items-center gap-8 text-sm font-medium text-neutral-600">
                        {NAV_ITEMS.map(([id, label]) => (
                            <button
                                key={id}
                                data-testid={`nav-link-${id}`}
                                onClick={() => scrollTo(id)}
                                className="link-underline hover:text-black transition-colors"
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                    <button
                        data-testid="nav-mobile-toggle"
                        onClick={() => setOpen((o) => !o)}
                        aria-label={open ? "Sluit menu" : "Open menu"}
                        className="md:hidden w-11 h-11 flex items-center justify-center rounded-full bg-black text-white hover:scale-105 transition-transform"
                    >
                        {open ? (
                            <X className="w-5 h-5" />
                        ) : (
                            <Menu className="w-5 h-5" />
                        )}
                    </button>
                </div>
            </nav>

            {/* Mobile menu overlay */}
            <div
                data-testid="mobile-menu"
                className={`md:hidden fixed inset-0 z-40 bg-white transition-all duration-500 ${
                    open
                        ? "opacity-100 pointer-events-auto"
                        : "opacity-0 pointer-events-none"
                }`}
            >
                <div className="pt-28 px-8 flex flex-col gap-2">
                    {NAV_ITEMS.map(([id, label], i) => (
                        <button
                            key={id}
                            data-testid={`mobile-nav-link-${id}`}
                            onClick={() => scrollTo(id)}
                            style={{
                                transitionDelay: open ? `${i * 60}ms` : "0ms",
                            }}
                            className={`text-left font-heading text-4xl font-bold tracking-tighter py-3 border-b border-black/10 text-black transition-all duration-500 ${
                                open
                                    ? "opacity-100 translate-y-0"
                                    : "opacity-0 translate-y-4"
                            }`}
                        >
                            {label}
                        </button>
                    ))}
                </div>
            </div>
        </>
    );
};
